import {getUserById, getList, getOne} from "./getData"
import {setCreate, setUpdate, setDelete} from './setData'

const jusers = {
  namespaced: true,
  state: {
    listaUsers: [],
    loading: false,
    listSelectUsers: [],
    idSelected: '',
    userSelected: {}
  },
  mutations: {
    updateList: (state, list) => {
      state.listaUsers = list
      list.forEach(item => state.listSelectUsers.push({
        text: item.name + ' ' + item.lastname1 + ' ' + item.lastname2,
        value: item._id,
        photo: item.photo
      }))
    },
    updateOneToList: (state, user) => {
      if (user) {
        const searchList = state.listaUsers.find(item => item._id === user._id)
        if (!searchList) {
          state.listaUsers.push(user)
        }
      }
    },
    updateOne: (state, one) => {
      state.userSelected = one
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => state.loading = loading,
    updateClearOne: (state) => {
      state.userSelected = {}
      state.idSelected = ''
    }
  },
  actions: {
    setSearch({commit}, id) {
      getUserById(commit, id)
    },
    setInit: ({commit}) => getList(commit),
    setCreateNew: ({commit}, user) => {
      setCreate(user)
      setTimeout(function() {
        getList(commit)
      }, 2000)
    },
    setUpdateUser: ({commit}, user) => {
      setUpdate(user)
      setTimeout(function() {
        getList(commit)
      },2000)
    },
    setDeleteUser: ({commit}, id) => {
      setDelete(id)
      setTimeout(function() {
        getList(commit)
      },2000)
    },
    setOne: ({commit}, id) => {
      getOne(commit, id)
    },
    setClearOne: ({commit}) => {
      commit('updateClearOne')
    }
  }
}

export default jusers